// src/components/skeleton/TipListSkeleton.js
import React from 'react';
import './TipListSkeleton.css';

export default function TipListSkeleton() {
  return (
    <div className="tiplist-skeleton-container">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="tiplist-skeleton-item">
          <div className="tiplist-skeleton-avatar shimmer"></div>
          <div className="tiplist-skeleton-lines">
            <div className="tiplist-skeleton-line short shimmer"></div>
            <div className="tiplist-skeleton-line shimmer"></div>
          </div>
        </div>
      ))}
    </div>
  );
}
